import Vue from 'vue';
import { registerComponents } from 'pdk/infrastructure';
import AppView from './errors/app-view';


registerComponents(Vue, [
	AppView
]);